import { useRouteError } from 'react-router-dom';

import { ChunkLoadRecoveryError, handleChunkLoadFailure, isChunkLoadError } from '@/utils/chunkLoadError';

type RouteError = Error & { status?: number; statusText?: string };

function ChunkLoadFailedFallback({ message }: { message?: string }) {
  return (
    <div style={{ padding: 48, textAlign: 'center', color: 'var(--color-text-1, #1d2129)' }}>
      <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, marginTop: 200 }}>页面资源加载失败</div>
      <div style={{ fontSize: 13, color: 'var(--color-text-3, #86909c)', marginBottom: 16 }}>
        {message || '请强制刷新页面（Ctrl/Cmd+Shift+R），或稍后再试。若刚完成发版，清除缓存后重试即可。'}
      </div>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: '6px 16px',
          borderRadius: 4,
          border: '1px solid var(--color-border-2, #e5e6eb)',
          background: '#fff',
          cursor: 'pointer',
        }}
      >
        刷新页面
      </button>
    </div>
  );
}

function ErrorBoundary() {
  const err = useRouteError() as RouteError;

  if (err instanceof ChunkLoadRecoveryError) {
    return <ChunkLoadFailedFallback message={err.message} />;
  }

  if (isChunkLoadError(err)) {
    if (handleChunkLoadFailure(err.message)) {
      return null;
    }
    return <ChunkLoadFailedFallback />;
  }

  return (
    <div>
      <strong>Error {err.status || 500}</strong>: {err.statusText ?? err.message}
    </div>
  );
}

export default ErrorBoundary;
